import React from 'react';

import {
    Heading,
    Container,
    Row,
    Col,
    Text,
    chunkArray,
    ImageComponent,
} from 'aplazame-design-system';

import textStyle from 'aplazame-design-system/src/scss/text.module.scss';
import style from './style.module.scss';

export default function FeaturePointsAlternativeSection({
    title,
    titleTag,
    image,
    id,
    points,
}) {
    return (
        <section
            aria-labelledby={id}
        >
            <Container
                pt={{
                    xs: 15,
                    lg: 15,
                }}
                pb={{
                    lg: 5,
                }}
            >
                <Row className="align-items-lg-center">
                    <Col
                        col={{ lg: 4 }}
                        pb={{ xs: 10, lg: 0 }}
                        data-sal="slide-up--lg-right"
                    >
                        <ImageComponent className={style.image} image={image} />
                    </Col>
                    <Col offset={{ lg: 1 }} col={{ lg: 7 }}>
                        <Heading
                            id={id}
                            tag={titleTag}
                            className={`h2 mb-8 mb-lg-5 ${textStyle.gradual} ${style.heading}`}
                            data-sal="slide-up--lg-left"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                        {chunkArray(points, 2).map((pointGroup, i) => (
                            <Row key={i}>
                                {pointGroup.map((point, ii) => (
                                    <Col
                                        key={ii}
                                        col={{ lg: 6 }}
                                        pb={{ xs: 5, lg: 0 }}
                                        pt={{ lg: 5 }}
                                        data-sal="slide-up--lg-left"
                                        data-sal-easing="ease-out-quart"
                                    >
                                        {point.title ? (
                                            <Heading
                                                tag="h5"
                                                className={`${style.subHeading}`}
                                            >
                                                {point.title}
                                            </Heading>
                                        ) : null}
                                        {point.textNode &&
                                            point.textNode.contentWithoutWrapper ? (
                                            <Text
                                                tag="div"
                                                className={`body ${style.body}`}
                                            >
                                                {
                                                    point.textNode
                                                        .contentWithoutWrapper
                                                }
                                            </Text>
                                        ) : null}
                                    </Col>
                                ))}
                            </Row>
                        ))}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
